module.exports = __webpack_public_path__ + "media/images/delete-disable-e933a3e80e300253696a933bbf899970.svg";